/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { DataBaseService } from '../data-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CreateDataStoreRequestDto } from '../models/create-data-store-request-dto';
import { StoresResponseDto } from '../models/stores-response-dto';
import { UpdateDataStoreRequestDtoPartial } from '../models/update-data-store-request-dto-partial';

@Injectable({ providedIn: 'root' })
export class StoresControllerService extends DataBaseService {

  /**
   * Path part for operation storesControllerGetStore
   */
  static readonly StoresControllerGetStorePath = '/v1/entities/{entityId}/stores/{storeId}';

  /**
   * Get a store for an entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getStore()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStore$Response(params: {
    entityId: string;
    storeId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<StoresResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, StoresControllerService.StoresControllerGetStorePath, 'get');
    if (params) {
      rb.path('entityId', params.entityId, {});
      rb.path('storeId', params.storeId, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StoresResponseDto>;
      })
    );
  }
  /**
   * Get a store for an entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getStore$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getStore(params: {
    entityId: string;
    storeId: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StoresResponseDto> {

    return this.getStore$Response(params).pipe(
      map((r: StrictHttpResponse<StoresResponseDto>) => r.body as StoresResponseDto)
    );
  }

  /**
   * Path part for operation storesControllerUpdateStore
   */
  static readonly StoresControllerUpdateStorePath = '/v1/entities/{entityId}/stores/{storeId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateStore()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateStore$Response(params: {
    entityId: string;
    storeId: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: UpdateDataStoreRequestDtoPartial
  }): Observable<StrictHttpResponse<StoresResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, StoresControllerService.StoresControllerUpdateStorePath, 'put');
    if (params) {
      rb.path('entityId', params.entityId, {});
      rb.path('storeId', params.storeId, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StoresResponseDto>;
      })
    );
  }
  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateStore$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateStore(params: {
    entityId: string;
    storeId: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: UpdateDataStoreRequestDtoPartial
  }): Observable<StoresResponseDto> {

    return this.updateStore$Response(params).pipe(
      map((r: StrictHttpResponse<StoresResponseDto>) => r.body as StoresResponseDto)
    );
  }

  /**
   * Path part for operation storesControllerGetAllStores
   */
  static readonly StoresControllerGetAllStoresPath = '/v1/entities/{entityId}/stores';

  /**
   * Get all stores for an entity including default stores
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllStores()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllStores$Response(params: {
    entityId: string;
    filterCriteria?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<StoresResponseDto>>> {

    const rb = new RequestBuilder(this.rootUrl, StoresControllerService.StoresControllerGetAllStoresPath, 'get');
    if (params) {
      rb.path('entityId', params.entityId, {});
      rb.query('filterCriteria', params.filterCriteria, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<StoresResponseDto>>;
      })
    );
  }
  /**
   * Get all stores for an entity including default stores
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllStores$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllStores(params: {
    entityId: string;
    filterCriteria?: any;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<StoresResponseDto>> {

    return this.getAllStores$Response(params).pipe(
      map((r: StrictHttpResponse<Array<StoresResponseDto>>) => r.body as Array<StoresResponseDto>)
    );
  }

  /**
   * Path part for operation storesControllerCreateStore
   */
  static readonly StoresControllerCreateStorePath = '/v1/entities/{entityId}/stores';

  /**
   * Create a new store for an entity
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createStore()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createStore$Response(params: {
    entityId: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: CreateDataStoreRequestDto
  }): Observable<StrictHttpResponse<StoresResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, StoresControllerService.StoresControllerCreateStorePath, 'post');
    if (params) {
      rb.path('entityId', params.entityId, {});
      rb.body(params.body, 'application/json');
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<StoresResponseDto>;
      })
    );
  }
  /**
   * Create a new store for an entity
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createStore$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createStore(params: {
    entityId: string;
    extraParams?: HttpParams,
    context?: HttpContext
    body?: CreateDataStoreRequestDto
  }): Observable<StoresResponseDto> {

    return this.createStore$Response(params).pipe(
      map((r: StrictHttpResponse<StoresResponseDto>) => r.body as StoresResponseDto)
    );
  }

}
